import BlankPage from './BlankPage';

export default BlankPage;
